module.exports = __webpack_public_path__ + "img/partner_elmu.7da4bd49.png";